import { SvgIcon, SvgIconProps } from '@mui/material'

export const AdyenCardIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="28" height="22" viewBox="0 0 28 22" fill="none" data-testid="AdyenCardIcon">
      <path
        d="M3.33341 21.6666C2.60008 21.6666 1.9723 21.4055 1.45008 20.8833C0.927859 20.3611 0.666748 19.7333 0.666748 19V2.99998C0.666748 2.26665 0.927859 1.63887 1.45008 1.11665C1.9723 0.594424 2.60008 0.333313 3.33341 0.333313H24.6667C25.4001 0.333313 26.0279 0.594424 26.5501 1.11665C27.0723 1.63887 27.3334 2.26665 27.3334 2.99998V19C27.3334 19.7333 27.0723 20.3611 26.5501 20.8833C26.0279 21.4055 25.4001 21.6666 24.6667 21.6666H3.33341ZM3.33341 11H24.6667V5.66665H3.33341V11Z"
        fill="#013654"
      />
    </SvgIcon>
  )
}
